import { ApplicationRef, inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

/**
 * Workaround for a zoneless dialog-activation gap.
 *
 * Under zoneless, a MatDialog opened imperatively (especially from within another dialog's event
 * handler — e.g. an "Are you sure?" confirmation opened from a dialog's close button) can render its
 * overlay without its content being change-detected, leaving the dialog's buttons unresponsive to
 * real clicks (the handler never fires). Flushing change detection right after each open lets the
 * freshly-created content activate.
 *
 * Refs: angular/components#28456, angular/angular#58075.
 */
@Injectable({ providedIn: 'root' })
export class ZonelessDialogActivationService {
  private dialog = inject(MatDialog);
  private appRef = inject(ApplicationRef);

  init(): void {
    this.dialog.afterOpened.subscribe(() => {
      queueMicrotask(() => {
        if (!this.appRef.destroyed) {
          this.appRef.tick();
        }
      });
    });
  }
}
